import { Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ReportsView from '../../../components/dashboard/admin/reports/ReportsView';

export default function Reports() {
  
  return (
    <>
      <Helmet>
        <title>Super Admin Reports | Platform Solutions</title>
      </Helmet>

      <Grid>
        <ReportsView />
      </Grid>
    </>
  );
}